import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireOrgFeature } from '../lib/orgFeatureGate';

// SIL-1071: Market Intelligence section layout (docs/superpowers/specs/
// 2026-09-16-market-intelligence-design.md §4). Sibling screens — the saved
// analyses list (index.tsx), the builder ($analysisId.tsx, SIL-1072), and
// cost-settings.tsx (this issue) — mount under this same layout. Bare
// Outlet, following financials.tsx's precedent, so future merges never
// touch this file.
//
// This layout's own fullPath (`/market-intelligence`) is the one
// CUSTOMER_NAV entry for this section — same shape as financials/
// scenarios.tsx, whose layout is likewise a bare-Outlet ALLOWLISTED module
// (allowlist.ts) while its `index.tsx` child owns the single PageHeader
// (title="Scenarios", pinTo="/financials/scenarios"). market-intelligence/
// index.tsx follows the identical pattern here (title="Market
// Intelligence", pinTo="/market-intelligence").
//
// SIL-1102: `orgFeature: 'marketIntel'` (customerNav.ts) is a business-only
// feature. The root `OrgFeatureGate` (__root.tsx) already redirects an
// individual org that hits this section, but it's a `useEffect` that only
// fires once `useAuth()`'s identity query resolves — it runs strictly AFTER
// this route's own `beforeLoad`/child-`beforeLoad` chain, so a direct
// `/market-intelligence` hit fired the child index route's cost-constants
// fetch (`GET /api/client/buyer-cost-constants`, 403 for an individual org)
// before the redirect ever landed. Gating here, in the layout's own
// `beforeLoad`, runs before ANY child route's `beforeLoad`/loader/component,
// so every screen in this section (index, cost-settings, $analysisId) is
// covered by one check.
//
// SIL-1108: the check itself moved to `requireOrgFeature` (lib/
// orgFeatureGate.ts) — see that module's docstring for the full semantics
// (identity fetch failure doesn't redirect, null org type does) — so every
// other business-only section layout shares this implementation instead of
// copying it.
export const Route = createFileRoute('/market-intelligence')({
  beforeLoad: () => requireOrgFeature('marketIntel'),
  component: () => <Outlet />,
});
